import { ReduxService } from 'dashboard-services/services';

import { diagramCustomInsightActions } from 'actions/modules/insight';

export const diagramCustomReducer = (state, action) => {
  switch (action.type) {
    case diagramCustomInsightActions.DISCONNECT_REDUX_NODES: {
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({ links: (state.content.tiles[action.tileIndex].links || []).filter(link => link.id !== action.id), activeNodeId: "" }, action.tileIndex) 
        })
      })
    }
    case diagramCustomInsightActions.REMOVE_REDUX_NODE: {
      const tile = state.content.tiles[action.tileIndex] || {}
      const nodes = ReduxService.updateObject(tile.nodes, {})
      const positions = ReduxService.updateObject(tile.positions, {})
      delete nodes[action.nodeId]
      delete positions[action.nodeId]
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({ nodes, positions }, action.tileIndex) 
        })
      })
    }
    case diagramCustomInsightActions.CHANGE_POSITION:
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({ 
            positions: ReduxService.updateObject(
              state.content.tiles[action.tileIndex].positions, 
              { 
                [action.nodeId]: { 
                  x: action.position.x, 
                  y: action.position.y 
                } 
              }
            ) 
          }, action.tileIndex) 
        })
      })
    case diagramCustomInsightActions.ADD_REDUX_NODE:
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({ nodes: ReduxService.updateObject(state.content.tiles[action.tileIndex].nodes, { [action.node.getId()]: { label: action.node.getDiagramType(), type: action.node.getDiagramType(), nodeWidth: "160" } }) }, action.tileIndex) 
        })
      })
    case diagramCustomInsightActions.SET_ACTIVE_PORT:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({ 
            activePortType: action.activeType, 
            activePortIsInput: action.input, 
            activeNodeId: action.id 
          }, action.tileIndex)
        })
      })
    case diagramCustomInsightActions.CONNECT_NODES:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            links: state.content.tiles[action.tileIndex].links.add(action.link),
            activePortType: undefined, 
            activePortIsInput: undefined,
            activeNodeId: undefined
          }, action.tileIndex)
        })
      })
    case diagramCustomInsightActions.ON_CHANGE_REDUX_NODE: {
      if(state.content.tiles[action.tileIndex].nodes?.[action.nodeId]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, {
          content: ReduxService.updateObject(state.content, { 
            tiles: state.content.tiles.updateInList({
              nodes: ReduxService.updateObject(state.content.tiles[action.tileIndex].nodes, {
                [action.nodeId]: ReduxService.updateObject(state.content.tiles[action.tileIndex].nodes[action.nodeId], { [action.name]: action.value })
              })
            }, action.tileIndex)
          })
        })
      }
      return state;
    }
    default:
      return undefined;
  }
}